import {FC, useEffect, useRef, useState} from 'react'
import {OrderItemModel} from '../../orders/models/OrderItemModel'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import ReactBeforeSliderComponent from 'react-before-after-slider-component'
import Tooltip from 'react-tooltip-lite'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import {ItemStatus, OrderType} from '../../orders/constants'
import {useDispatch} from 'react-redux'
import {filterDataChange, selectItemList, selectItemLoading, selectItemsFilter, setHistoryAsMainOutput} from '../redux/itemRedux'
import {useAppSelector} from '../../../../setup/redux/hooks'

import {ItemDisplayMode} from '../constants'
import ItemViewMode from './itemViewMode'
import './itemViewBox.scss'
import ItemRating from './itemRating'
import ItemActionBox from '../../orders/components/ItemActionBox'
import ItemProcessHistory from './itemProcessHistory'
import {ItemProcessHistoryModel} from '../models/ItemProcessHistoryModel'
import {Spinner} from 'react-bootstrap-v5'
interface Props {
  item: OrderItemModel
  onNext: (id: number) => void
  onPrev: (id: number) => void
  toggleSettings: () => void
  onSelect: (id: number) => void
}

const ItemViewBox: FC<Props> = (props) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const filter = useAppSelector(selectItemsFilter)
  const orderItems = useAppSelector(selectItemList)
  const loading = useAppSelector(selectItemLoading)
  const didRequest = useRef(false)
  const [viewMode, setViewMode] = useState(
    props.item.status === ItemStatus.DONE ? ItemDisplayMode.Compare : ItemDisplayMode.Original
  )
  const [selectedHistory, setSelectedHistory] = useState<ItemProcessHistoryModel | undefined>(undefined)
  // const [currenItem, setCurrentItem] = useState(props.item)
  const currenItem = props.item

  const getFileName = (path?: string) => {
    if (!path) {
      return ''
    }
    const normalizedPath = path.split('?')[0]
    const segments = normalizedPath.split('/')
    return (segments[segments.length - 1] || '').trim()
  }

  const resolveHistoryImageUrl = (path?: string) => {
    if (!path) {
      return undefined
    }

    if (/^(https?:|data:|blob:)/i.test(path)) {
      return path
    }

    const apiUrl = process.env.REACT_APP_API_URL
    if (!apiUrl) {
      return path
    }

    try {
      const origin = new URL(apiUrl).origin
      return `${origin}/${path.replace(/^\/+/, '')}`
    } catch (error) {
      return path
    }
  }

  const currentItemOutputFileName = getFileName(
    currenItem.outputImageUrl?.original ||
      currenItem.outputImageUrl?.medium ||
      currenItem.outputImageUrl?.small ||
      currenItem.outputImageUrl?.tiny
  )
  const selectedHistoryOutputFileName = getFileName(selectedHistory?.output)
  const isCurrentOutputRevision =
    !selectedHistory ||
    (selectedHistoryOutputFileName.length > 0 &&
      selectedHistoryOutputFileName === currentItemOutputFileName)

  const currentInputImage = selectedHistory
    ? resolveHistoryImageUrl(selectedHistory.input) || currenItem.inputImageUrl?.medium
    : currenItem.inputImageUrl?.medium

  const currentOutputImage = selectedHistory
    ? resolveHistoryImageUrl(selectedHistory.output) || currenItem.outputImageUrl?.medium
    : currenItem.outputImageUrl?.medium

  const getAllOrderItems = async () => {
    if (!didRequest.current) {
      dispatch(filterDataChange({...filter, orderId: currenItem.orderId, take: 50}))
    }

    return () => (didRequest.current = true)
  }
  useEffect(() => {
    getAllOrderItems()
  }, [props.item])

  useEffect(() => {
    setSelectedHistory(undefined)
  }, [currenItem.id])

  const setCurrentOrderItem = (itemId: number) => {
    const targetItem = orderItems.find((item) => item.id === itemId)
    if (targetItem) {
      props.onSelect(itemId)
    }
  }

  const onUpdateAsOutput = async () => {
    if (!selectedHistory) {
      return
    }
    dispatch(setHistoryAsMainOutput({itemId: currenItem.id, historyId: selectedHistory.id}))
  }

  const renderActions = () => {
    console.log('currenItem', currenItem)
    return (
      <>
        {currenItem.type !== OrderType.PROFESSIONAL && !currenItem.isAutoSettingOrder && (
          <Tooltip content={intl.formatMessage({id: 'ITEM.ACTIONS.SETTING'})} className='tooltips'>
            <button
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setViewMode(ItemDisplayMode.Output)
                props.toggleSettings()
              }}
              disabled={currenItem.status !== ItemStatus.DONE}
              className='btn btn-icon btn-sm btn-info ms-3'
            >
              <i className='bi fs-2 bi-gear'></i>
            </button>
          </Tooltip>
        )}

        <Tooltip content={intl.formatMessage({id: 'ITEM.ACTIONS.BACK'})} className='tooltips'>
          <Link
            to={'/orders/' + props.item.orderId}
            className='btn btn-icon btn-sm btn-secondary ms-3'
          >
            <i className='bi fs-1 bi-arrow-left-short'></i>
          </Link>
        </Tooltip>
      </>
    )
  }
  return (
    <div className='card'>
      <div className='card-header cursor-pointer d-flex justify-content-between'>
        <div className='card-toolbar'>
          <ItemViewMode
            isOrderCompleted={currenItem.status === ItemStatus.DONE}
            mode={viewMode}
            onChangeMode={setViewMode}
          />
        </div>
        <div className='card-toolbar'>
          {isCurrentOutputRevision ? (
            <ItemRating item={currenItem} />
          ) : (
            <button
              type='button'
              className='btn btn-sm btn-primary'
              disabled={loading || !selectedHistory}
              onClick={onUpdateAsOutput}
            >
              {loading ? (
                <Spinner size='sm' animation='border' />
              ) : (
                intl.formatMessage({id: 'ItemDetail.Actions.UPDATE_AS_OUTPUT'})
              )}
            </button>
          )}
        </div>
        <div className='card-toolbar'>
          <ItemActionBox item={currenItem} />
          {renderActions()}
        </div>
      </div>
      <div className='main-item-image card-body p-5 d-flex justify-content-between'>
        <button
          type='button'
          disabled={currenItem.id === orderItems[0]?.id}
          className='btn btn-light-outline-primary'
          onClick={() => setCurrentOrderItem(currenItem.id + 1)}
        >
          <i
            style={{
              fontSize: '50px',
            }}
            className='bi bi-arrow-left-circle text-primary font-weight-bold'
          ></i>
        </button>
        <div style={{maxHeight: '700px'}}>
          {viewMode !== ItemDisplayMode.Compare && (
            <LazyLoadImage
              src={
                viewMode === ItemDisplayMode.Original
                  ? currentInputImage
                  : currentOutputImage
              }
              alt={currenItem.name}
              style={{
                transition: 'opacity 0.5s, filter 0.5s', // Add transitions for both opacity and filter
              }}
              placeholderSrc={toAbsoluteUrl('/media/loading-bg.gif')}
              effect='blur'
              onError={(event: any) => {
                if (event?.target?.src) event.target.src = toAbsoluteUrl('/media/loading-bg.gif') // Replace with your default image URL
              }}
            />
          )}

          {viewMode === ItemDisplayMode.Compare && (
            <ReactBeforeSliderComponent
              className='compare-detail-item'
              firstImage={{
                imageUrl: currentOutputImage ?? '',
                alt: 'Before',
              }}
              secondImage={{
                imageUrl: currentInputImage ?? '',
                alt: 'After',
              }}
            />
          )}
        </div>
        <button
          type='button'
          disabled={currenItem.id === orderItems[orderItems.length - 1]?.id}
          className='btn btn-light-outline-primary'
          onClick={() => setCurrentOrderItem(currenItem.id - 1)}
        >
          <i
            style={{
              fontSize: '50px',
            }}
            className='bi text-primary bi-arrow-right-circle'
          ></i>
        </button>
      </div>
      <ItemProcessHistory
        itemId={currenItem.id}
        inline
        selectedHistoryId={selectedHistory?.id}
        onSelectHistory={setSelectedHistory}
      />
    </div>
  )
}
export default ItemViewBox
